var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import { Handicap } from "../../modules/handicap";
import { Players } from "../../modules/players";
import { Utilities } from "../../services/utilities";
// Define vue parameters
var HandicapComponent = /** @class */ (function (_super) {
    __extends(HandicapComponent, _super);
    /**
     * Setup the child and parent class
     */
    function HandicapComponent() {
        var _this = _super.call(this) || this;
        // Create a clubs instance
        _this.handicap = new Handicap();
        // Create a players instance
        _this.player = new Players();
        return _this;
    }
    /**
     * Component setup on mount
     */
    HandicapComponent.prototype.mounted = function () {
        var _this = this;
        var self = this;
        if (this.$props.playerId === "me") {
            this.$data.showEdit = true;
        }
        // Get handicap entries
        this.handicap.entries(this.$props.playerId, 1, 20).then(function (r) {
            _this.$data.HandicapEntryCollection = r;
            _this.$data.HandicapEntries = r.handicapEntries;
        });
        var currentDate = new Date();
        this.player.get(this.$props.playerId).then(function (playerResponse) {
            _this.$data.playerData = playerResponse;
            _this.player
                .getExtendedStats(_this.$props.playerId, 1, 12, currentDate.getMonth(), currentDate.getFullYear() - 1)
                .then(function (playerExtResponse) {
                // Get Chart Data
                var chartData = _this.getChartDataFromExtendedStats(playerExtResponse, _this.$data.playerData.handicap);
                _this.$data.chartData = chartData;
                // Set Total Average
                _this.$data.handicapCollectionAverage =
                    chartData.totalAverageHandicap;
                // Set playerextendedstats Data
                _this.$data.playerExtendedStatsData = playerExtResponse;
                _this.$data.handicapDelta =
                    playerResponse.handicap -
                        _this.$data.handicapCollectionAverage;
                _this.$data.loading = false;
            });
        });
    };
    /**
     * Build chart data array from extended stats results
     */
    HandicapComponent.prototype.getChartDataFromExtendedStats = function (extendedStats, handicap) {
        var chartValues = [];
        var chartLabels = [];
        var chartLabelPointRadii = [];
        var totalAverageHandicap = 0;
        if (extendedStats.playerExtendedStats.length <= 0) {
            return this.getChartDataFromHandicap(handicap);
        }
        var chartData = extendedStats.playerExtendedStats;
        /**
         * API data doesn't seem to be respecting monthMin/yearMin
         * parameters, manually limit data set here.
         *
         * @TODO - Identify what is causing this in the API and
         * remove this fix
         */
        chartData = chartData.slice(0, 12).reverse();
        chartData.forEach(function (monthData, index) {
            chartValues.push(monthData.averageHandicap);
            // Use second day of the month (-02) to avoid returning previous month from timezone discrepancies
            var date = new Date(monthData.players[0].year +
                "-" +
                monthData.players[0].month +
                "-02");
            // Format labels (ex: Jan '20), middle results will be stripped in graph tick label settings
            chartLabels.push(moment(date)
                .format("MMM 'YY")
                .toUpperCase());
            // Set last label point radius to 4, all others will be zero
            chartLabelPointRadii.push(index < chartData.length - 1 ? 0 : 4);
        });
        // Get the total average of all average handicaps from each row
        totalAverageHandicap =
            chartData.reduce(function (total, next) { return total + next.averageHandicap; }, 0) /
                chartData.length;
        return {
            data: chartValues,
            labels: chartLabels,
            labelPointRadii: chartLabelPointRadii,
            totalAverageHandicap: totalAverageHandicap
        };
    };
    /**
     * If no recent extended stats are available, use the overall handicap to
     * generate 2 data points for the graph.
     */
    HandicapComponent.prototype.getChartDataFromHandicap = function (handicap) {
        var chartValues = [];
        var chartLabels = [];
        var chartLabelPointRadii = [];
        // Insert 2 identical entries
        chartValues.push(handicap);
        chartValues.push(handicap);
        // Insert one data point 1 year ago and for this month
        var date = new Date();
        // Format labels (ex: Jan '20)
        chartLabels.push(moment(date)
            .subtract(1, "year")
            .format("MMM 'YY")
            .toUpperCase());
        chartLabels.push(moment(date)
            .format("MMM 'YY")
            .toUpperCase());
        // Only 2 points, both will be larger points
        chartLabelPointRadii.push(4);
        chartLabelPointRadii.push(4);
        return {
            data: chartValues,
            labels: chartLabels,
            labelPointRadii: chartLabelPointRadii,
            totalAverageHandicap: handicap
        };
    };
    HandicapComponent.prototype.openModal = function (handicapId) {
        this.$data.handicapId = handicapId;
        this.$modal.show("edit-handicap", {});
    };
    // @TODO - convert to Vue filter
    HandicapComponent.prototype.formatDate = function (date) {
        return moment(date).format("M/D/YY");
    };
    // @TODO - convert to Vue filter
    HandicapComponent.prototype.formatHandicap = function (value) {
        if (value) {
            return value.toFixed(1);
        }
        return '';
    };
    // @TODO - convert to Vue filter
    HandicapComponent.prototype.formatHandicapDelta = function (value) {
        return Math.abs(value).toFixed(1);
    };
    /**
     * Delete a handicap and update the view upon deletion
     */
    HandicapComponent.prototype.deleteEntry = function (handicapId, dataIndex) {
        var _this = this;
        Utilities.confirm("Are you sure you want to delete this handicap entry?").then(function () {
            // Delete the handicap
            _this.handicap["delete"](_this.$props.playerId, handicapId).then(function (r) {
                // Remove the handicap from the $data object
                _this.$delete(_this.$data.HandicapEntryCollection, dataIndex);
            });
        });
    };
    HandicapComponent.prototype.show = function () {
        this.$modal.show("hello-world");
    };
    HandicapComponent.prototype.hide = function () {
        this.$modal.hide("hello-world");
    };
    /**
     * Load more entries
     */
    HandicapComponent.prototype.showMore = function () {
        var _this = this;
        // The offset is used to paginate through entries
        var offset = this.$data.HandicapEntryCollection.handicapEntries.length + 1;
        // Append new entries to handicap data with offset from index
        this.handicap
            .entries(offset, this.$data.HandicapEntryCollection.to + 10)
            .then(function (r) {
            _this.$data.HandicapEntryCollection.handicapEntries.push(r.handicapEntries[0]);
            // Update metadata
            _this.$data.HandicapEntryCollection.from = r.from;
            _this.$data.HandicapEntryCollection.to = r.to;
        });
    };
    HandicapComponent = __decorate([
        Component({
            props: {
                playerId: [Number, String]
            },
            data: function () {
                return {
                    handicapId: null,
                    chartData: [],
                    handicapCollectionAverage: null,
                    handicapDelta: null,
                    HandicapEntryCollection: [],
                    HandicapEntries: [],
                    loading: true,
                    playerData: null,
                    playerExtendedStatsData: null,
                    showEdit: false
                };
            }
        })
        // Define the component code
    ], HandicapComponent);
    return HandicapComponent;
}(Vue));
export default HandicapComponent;
